import React from 'react'
import { FacetSelect } from '../BaseComponents/FacetSelect'

const FacetFilterType = () => (
  <FacetSelect
    facetCategory="productFilter"
    filterGroup="Type"
    source="filterTypeFacet"
  />
)

export default FacetFilterType
